@if (condition) {
  <div class="flex flex-col w-full gap-4 p-4 border border-white/10 rounded-xl bg-neutral-900/30 backdrop-blur">
    <div class="flex flex-col gap-3 md:flex-row md:items-end">
      <!-- Property Selector -->
      <div class="flex flex-col gap-1 md:flex-[1.25]">
        <span class="text-[11px] uppercase tracking-wide text-white/45">Field</span>
        <nrc-input-nested-select
          [formControl]="condition.controls.propertyName"
          [options]="nestedPropertyOptions()"
          [labelProperty]="'label'"
          [valueProperty]="'value'"
          [childrenProperty]="'children'"
          [overflowParentElement]="overflowParentElement"
          [placeholder]="'Select property...'"
        />
      </div>

      @if (selectedField()) {
        <!-- Operator Selector -->
        <div class="flex flex-col gap-1 md:w-48">
          <span class="text-[11px] uppercase tracking-wide text-white/45">Operator</span>
          <nrc-input-select
            [formControl]="condition.controls.rule"
            [options]="ruleOptions()"
            [labelProperty]="'label'"
            [valueProperty]="'value'"
            [overflowParentElement]="overflowParentElement"
            [searchEnabled]="false"
          />
        </div>

        <!-- Value Input -->
        <div class="flex flex-col flex-1 gap-1">
          <span class="text-[11px] uppercase tracking-wide text-white/45">Value</span>
          <div class="flex w-full min-h-11 items-center">
            @if (selectedField()) {
              @switch (selectedField()?.type?.toLowerCase()) {
                @case ('datetime') {
                  <nrc-input-datepicker
                    class="flex w-full rounded-lg text-cyan-500"
                    [formControl]="condition.controls.propertyValue"
                  />
                }
                @case ('boolean') {
                  <nrc-input-segment
                    class="flex h-11 rounded-lg text-cyan-500"
                    [formControl]="condition.controls.propertyValue"
                    [options]="[
                      { value: false, label: 'false' },
                      { value: true, label: 'true' }
                    ]"
                  />
                }
                @default {
                  <nrc-input-text
                    class="flex items-center w-full h-11 rounded-lg text-cyan-500"
                    [type]="'text'"
                    [formControl]="condition.controls.propertyValue"
                    [clearEnabled]="false"
                  />
                }
              }
            }
          </div>
        </div>
      }
    </div>

  </div>
}
